/**
* @ngdoc service
* @name common.service:NaverLoginService
* @description
* Naver Login.
*/
(function() {
  'use strict';

  angular
  .module('itxApp.common')
  .service('NaverLoginService', NaverLoginService);

  NaverLoginService.$inject = [
    'ItxLoginSvc',
    '$http'
  ];

  function NaverLoginService (
    ItxLoginSvc
  ) {

    var service =  {
      login: login,
      setNaverLoginProcessing: setNaverLoginProcessing,
      getNaverLoginProcessing: getNaverLoginProcessing
    };

    var naverLoginProcessing;

    return service;

    function setNaverLoginProcessing(data){
      naverLoginProcessing = data;
    }

    function getNaverLoginProcessing(){
      return naverLoginProcessing;
    }

    function login(user){
      ItxLoginSvc.socialLogin(user)
      .then(function (userJSON) {
        inditex.iUserJSON = userJSON;
        sessionStorage.setItem("cache-current-user", JSON.stringify(inditex.iUserJSON));
      });
    }
  }

})();